import React from 'react'

import AppraisalTable from './appraisal_table'
import SingleCell from './appraisal/table/SingleCell'
import ImageCell  from './appraisal/table/ImageCell'
import DoubleCell from './appraisal/table/DoubleCell'
import numeral from 'numeral'

function AppraisalResults({ data }) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Qty.',
        accessor: 'quantity',
        sortType: 'basic',
        Cell: (tableInstance, cellModel) => <SingleCell data={numeral(tableInstance.cell.value).format('0,0')} style={{textAlign:'right'}} />
      },

      {
        Header: 'Name',
        accessor: 'name',
        Cell: (tableInstance, cellModel) => <ImageCell image={tableInstance.row.original.id} text={tableInstance.cell.value} />
      },

      {
        Header: () => ( <>Volume&nbsp;(Single)<br />Volume&nbsp;(Stack)</> ),
        accessor: 'volume',
        sortType: 'basic',
        Cell: (tableInstance, cellModel) => {
          let bottomData = tableInstance.cell.value * tableInstance.row.values.quantity;
          return (<DoubleCell
            topData={numeral(tableInstance.cell.value).format('0,0.00')}
            bottomData={numeral(bottomData).format('0,0.00')}
            style={{textAlign:'right'}} />);
        }
      },

      {
        Header: () => ( <>Jita&nbsp;Sell&nbsp;(Single)<br />Jita&nbsp;Sell&nbsp;(Stack)</>),
        accessor: 'sell',
        sortType: 'basic',
        Cell: (tableInstance, cellModel) => {
          let bottomData = tableInstance.cell.value * tableInstance.row.values.quantity;
          return (<DoubleCell
            topData={numeral(tableInstance.cell.value).format('0,0.00')}
            bottomData={numeral(bottomData).format('0,0.00')}
            style={{textAlign:'right'}} />);
        }
      },

      {
        Header: () => ( <>Jita&nbsp;Buy&nbsp;(Single)<br />Jita&nbsp;Buy&nbsp;(Stack)</>),
        accessor: 'buy',
        sortType: 'basic',
        Cell: (tableInstance, cellModel) => {
          let bottomData = tableInstance.cell.value * tableInstance.row.values.quantity;
          return (<DoubleCell topData={numeral(tableInstance.cell.value).format('0,0.00')} bottomData={numeral(bottomData).format('0,0.00')} style={{textAlign:'right'}} />);
        }
      },

      {
        Header: 'Rate',
        accessor: 'rate',
        sortType: 'basic',
        Cell: (tableInstance, cellModel) => {
          let value = tableInstance.cell.value;
          if (value === undefined) {
            value = 0;
          }
          return <SingleCell data={ numeral(value).format('0%')} style={{textAlign:'right'}} />
        }
      },

      {
        Header: 'Price',
        accessor: (row, rowid, subrows) => ( row.quantity * row.buy * row.rate ),
        sortType: 'basic',
        id: 'price',
        Cell: (tableInstance, cellModel) => {
          let row = tableInstance.row.values;
          let value = row.quantity * row.buy * row.rate;
          value = numeral(value).format('0,0.00');
          return <SingleCell data={value} style={{textAlign:'right'}} />
        }
      },
    ],
    []
  )

  if (data === null) {
    return <>Nothing pasted</>
  }

  return <AppraisalTable columns={columns} data={data} />
}

export default AppraisalResults
